import React from 'react';
import * as style from './creditCallout.module.scss';

const CreditCallout = props => (
  <div className={`page-block text-block  reveal fadeInUp`}>
    <div className={style.creditCallout}>
      <div className={style.logoWrap}>
        <a href={props.link} target="_blank" rel="noopener">
          <img src={props.src} alt={props.alt} />
        </a>
      </div>
      <p>{props.text}</p>
    </div>
  </div>
);

export default CreditCallout;
